import { translate } from '../i18nService';

// Can be used for converting React nodes to string for structured data.
// For example with <Translate contennt="..." unsafe /> components.
const serializeToString = (node: any): string => {
  if (['string', 'number'].includes(typeof node)) return node;

  if (node?.props?.content && node?.props?.unsafe) {
    // eslint-disable-next-line @openclassrooms/translation-keys
    return translate(node.props.content, node.props.vars, node.props.count);
  }

  if (node instanceof Array) return node.map(serializeToString).join('');
  if (node?.props?.children) return serializeToString(node.props.children);
  return '';
};

export default serializeToString;
